/*
 * @file: login.js
 * @description: It is Container login screen .
 * @author: navreet
 */
import React from 'react'

const Empty = (props) => {
    return (
        <div className="dashboard" style={{ height: '550px' }}>
            <div class="bgimg">
                <div class="middle">
                    <h1>COMING SOON</h1>
                    <hr />
                </div>
            </div>
        </div>
    )
}

export default Empty
